import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=740317c8&scoped=true&"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js&"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailDialog.vue?vue&type=style&index=0&id=740317c8&scoped=true&lang=scss&"
import style1 from "./OrderDetailDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740317c8",
  null
  
)

export default component.exports